import ImpersonationBanner from "./ImpersonationBanner";

export default ImpersonationBanner;
